<template>
  <div class="card course-card course" @click="goStudy">
    <div
      class="text-center bg-dark course-banner"
      :class="{
        'bg-video': data.learningStyle !== 'FACE',
        'bg-face': data.learningStyle === 'FACE',
      }"
    >
      <span
        v-if="data.learningStyle === 'COURSEWARE'"
        class="badge badge-success rounded-pill px-2 type"
        >{{ data.learningStyleName }}</span
      >
      <span
        v-if="data.learningStyle === 'LIVE'"
        class="badge badge-warning rounded-pill px-2 type"
        >{{ data.learningStyleName }}</span
      >
      <span
        v-if="data.learningStyle === 'FACE'"
        class="badge badge-info rounded-pill px-2 type"
        >{{ data.learningStyleName }}</span
      >
      <span v-if="data.learningStyle === 'COURSEWARE'" class="duration"
        >{{ data.sumDuration }}分钟</span
      >
    </div>
    <div class="card-body">
      <h5 class="course-name">{{ data.courseName }}</h5>
      <div
        v-if="data.learningStyle !== 'FACE' && data.learningStyle !== 'LIVE'"
        class="d-flex align-items-center"
        style="font-size: 0.85rem"
      >
        <span v-if="data.duration >= data.sumDuration && data.sumDuration != 0" class="text-success">
          <b-icon-check-circle-fill
            variant="success"
            class="mr-1"
          ></b-icon-check-circle-fill>
          学习完成
        </span>
        <b-progress
          class="flex-grow-1"
          style="height: 0.75rem"
          :value="data.duration"
          :max="data.sumDuration"
          v-if="data.duration < data.sumDuration"
          show-progress
          animated
        ></b-progress>
        <span class="px-1">已学{{ data.duration }}分钟</span>
      </div>
    </div>
    <b-modal
      v-model="show"
      @ok="labelOk"
      @hidden="labelCancel"
      ref="labelModalShow"
      title="人脸比对"
      ok-title="拍照"
      cancel-title="关闭"
      :no-close-on-backdrop="true"
    >
      <div class="modal-body">
        　　<modal-camera
          v-if="show"
          ref="modalCamera"
          :data="data"
          :routerName="`study`"
          :threshold="threshold"
          :businessType="businessType"
          :businessId="businessId"
          :type="`face`"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "app-study-course",
  components: {
    ModalCamera: () => import("@/views/modalCamera.vue"),
  },
  props: {
    data: Object,
    studyTime: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      studyFaceComparison: this.$store.state.sysConfig.studyFaceComparison,
      threshold: this.$store.state.sysConfig.studyThreshold,
      businessType: "course",
      show: false,
    };
  },
  methods: {
    labelOk() {
      this.$refs.modalCamera.photo();
    },
    labelCancel() {
      this.show = false;
    },
    navigator() {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: true,
          })
          .then((stream) => {
            if (this.show === false) {
              this.show = true;
              this.$message({
                message: "请先点击拍照,系统将自动进行人脸比对!",
                type: "warning",
              });
            }
          })
          .catch((error) => {
            this.$message({
              message: "课程已开启人脸比对,请开启摄像头!",
              type: "error",
            });
          });
      }
    },
    async goStudy() {
      // if (this.data.learningStyle == "COURSEWARE") {
        if (this.studyTime) {
          const { studyStartTime, studyEndTime } = this.data;
          const time = new Date().getTime(),
            startTime = new Date(studyStartTime).getTime(),
            endTime = new Date(studyEndTime).getTime();
          if (time < startTime || time > endTime) {
            this.$message({
              message: "不在学习时间范围内",
              type: "warning",
            });
            return;
          }
        }
      // }
      if (this.data.learningStyle !== "FACE") {
        if (!this.data.studyRecordId) {
          const { data } = await this.axios.post("student/study/ready", {
            ...this.data.studyRecord,
          });
          this.$set(this.data, "studyRecordId", data);
          this.$set(this.data.studyRecord, "id", data);
        }
        const params = {
          schoolId: this.$store.state.user.regInfo.schoolId,
        };
        const { data } = await this.axios.get("/comm/findSysConfig", {
          params,
        });
        if (data && data.studyFaceComparison && navigator.mediaDevices) {
          this.businessId = this.data.studyRecordId;
          this.navigator();
        } else {
          this.goPage();
        }
      }
    },
    goPage() {
      this.$store.commit("SET_COURSE", this.data);
      this.$router.push({
        name: `study`,
      });
    },
  },
};
</script>

<style scoped>
.course-card {
  cursor: pointer;
  min-height: 235px;
}
.course-card .course-banner {
  position: relative;
  min-height: 150px;
}
.course-card .bg-face {
  background-image: url("../assets/face.png");
  background-size: cover;
}
.course-card .bg-video {
  background-image: url("../assets/play.png");
  background-position: center;
  background-size: 80px 80px;
  background-repeat: no-repeat;
}
.course-card .duration {
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  color: #ccc;
  font-weight: bold;
  font-size: 0.85rem;
}
.course-card .course-name {
  font-size: 1.1rem;
}
.course-card .type {
  position: absolute;
  left: 0.75rem;
  top: 0.75rem;
}
.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
